export default __webpack_public_path__ + "static/media/close.ecf05d86.svg";